module.exports = __webpack_public_path__ + "static/assets/715a94b834e7b5d6e9445e490579766a.png";